module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAMFBMVEUAAAD///////////////////////////////////////////////////////////87TQQwAAAAD3RSTlMAcO+fIN8wYK9AEJCAXx++M/S5AAAAoElEQVQI113OMQrCQBCF4ZFERCvT2aUSy01nmdxA8QLBXlDwAOIJkiPkCFYewQN4E3dZETT+ziJp8qoPhnk86WecFH/EM0MbMDmWUNpGeQc+sTnolTk8pcxEBhQpbsta6WUP8NUebvk7h4e+GcgieCkruCitMgWXux21yApCm5mKDLlWtDHKyIfDBh00skUKLMIc48EvG9GcsOdublJLLz/f1lHXNZaAVQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/image/new/game/game-tab1-active.png
// module id = IRMq
// module chunks = 1